import { logger } from '@parrot-software/observability';

import type { IInvoiceDataApiPort } from '@subscriptions/application/ports';
import { extractErrorAttributes } from '@subscriptions/application/utils';

const invoiceLog = logger.forDomain('SUB', { subdomain: 'billing' });

/**
 * Use case for deleting invoice data.
 *
 * @param port - Invoice data API port
 * @returns Use case executor
 */
export const deleteInvoiceDataUseCase = (port: IInvoiceDataApiPort) => {
  const execute = async (invoiceDataUuid: string): Promise<void> => {
    try {
      await port.delete(invoiceDataUuid);
      invoiceLog.info('deleteInvoiceData', { 'invoice.uuid': invoiceDataUuid });
    } catch (error) {
      invoiceLog.error('deleteInvoiceData', {
        ...extractErrorAttributes(error),
        'invoice.uuid': invoiceDataUuid,
      });
      throw error;
    }
  };

  return { execute };
};
